import { Card, Typography, Steps, Row, Col, List, Carousel } from 'antd';
import React, { useState } from 'react';

import { LockTwoTone, EyeInvisibleTwoTone, HourglassTwoTone, ControlTwoTone, QuestionCircleTwoTone} from '@ant-design/icons';
import '../styles/App.css'

const { Text, Link, Title } = Typography;

const mpiBlue = "#5497CC"


export const PageHome = () => {

    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });

    const [useMobileVersion, setUseMobileVersion] = useState(window.innerWidth <= 768);
    React.useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
            setUseMobileVersion(window.innerWidth <= 768);
        }

        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)

        }
    })

    const stepperCard = () => {
        // Warning Fix: Map your steps to the 'items' prop format
        const stepItems = [
            {
                className: useMobileVersion ? "InstructionStepMobile" : "InstructionStep",
                title: <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Complete our survey"}</div>,
                description: (
                    <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>
                        {"Once you provide your consent, you will be directed to a short survey related to demographics and use of the conversational-AI Platform."}
                    </div>
                ),
                status: "process",
            },
            {
                className: useMobileVersion ? "InstructionStepMobile" : "InstructionStep",
                title: <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Request your data"}</div>,
                description: (
                    <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>
                        {"If you choose to donate your data, follow our guides to request your data from the platform you use"}
                        {"."}
                    </div>
                ),
                status: "process",
            },
            {
                className: useMobileVersion ? "InstructionStepMobile" : "InstructionStep",
                title: <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Donate your data"}</div>,
                description: (
                    <div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>
                        {"Donate your data through our "}
                        <Link href="/donate" target="_self">data donation page</Link>
                        {", which allows you to choose which parts of your data you wish to donate (attachments, conversations, etc.), and transfers it to our infrastructure."}
                    </div>
                ),
                status: "process",
            }

        ];

        return (
            <Card className={useMobileVersion ? "StepperCardMobile" : "StepperCard"}>
            <Card.Meta
            title={<Text strong>How it works</Text>}
                    description={
                        <div style={{ width: "100%" }}>
                            <Steps
                            className="InstructionStepper"
                            labelPlacement="vertical"
                            responsive
                            items={stepItems}
                            />
                        </div>
                    }
                />
            </Card>
        );
    };

    const images = () => {
        const text1 = "How reliant are we on conversational AI systems in our daily lives?"
        const text2 = "How much trust do we place in conversational AI systems, and which societal roles are they beginning to replace?"
        const text3 = "What personal information do we share with conversational AI, and how is it used to personalize our conversations?";
        if (useMobileVersion) {
            return (
                < Carousel autoplay >
                    <div>
                    <Card cover={<img alt="" src={process.env.PUBLIC_URL + '/Images/Home_topics.png'} />}>{text1}</Card>
                    </div>
                    <div>
                    <Card cover={<img alt="" src={process.env.PUBLIC_URL + '/Images/Home_humans.jpg'} />}>{text2}</Card>
                    </div>
                    <div>
                    <Card cover={<img alt="" src={process.env.PUBLIC_URL + '/Images/Home_personalize.png'} />}>{text3}</Card>
                    </div>
                </Carousel >);
        }
        else {
            return (
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={8}>
                    <Card
                        className="HomeTopicCard"
                        cover={<img className="HomeTopicImage" alt="" src={process.env.PUBLIC_URL + '/Images/Home_topics.png'} />}
                    >
                        {text1}
                    </Card>
                    </Col>

                    <Col xs={24} md={8}>
                    <Card
                        className="HomeTopicCard"
                        cover={<img className="HomeTopicImage" alt="" src={process.env.PUBLIC_URL + '/Images/Home_humans.jpg'} />}
                    >
                        {text2}
                    </Card>
                    </Col>

                    <Col xs={24} md={8}>
                    <Card
                        className="HomeTopicCard"
                        cover={<img className="HomeTopicImage" alt="" src={process.env.PUBLIC_URL + '/Images/Home_personalize.png'} />}
                    >
                        {text3}
                    </Card>
                    </Col>
                </Row>
            );

        }
    }

    const textBoxes = () => {
        return (
            <Row gutter={[16, 16]} className="BottomMargin">
            <Col xs={24} md={14}>
                <Card className={useMobileVersion ? "MainHomeCardMobile" : "MainHomeCard"} title="About the project">
                        <Typography.Paragraph>  
                            We invite you to donate data from your conversational AI platforms (e.g., ChatGPT, Gemini, DeepSeek, Grok) to help us understand our growing relationship with these powerful systems. Much of this critical data is currently held exclusively by large companies, making it difficult for independent researchers to study their true impact.
                        </Typography.Paragraph>

                        <Typography.Paragraph>  
                            With your help, we can analyze the topics being discussed, explore how AI is reshaping human roles, and track how our reliance and trust in this technology is evolving over time. Your contribution will also allow us to investigate how these systems personalize their responses by understanding the nature and sensitivity of the data they collect, and how that information is used to shape future interactions.
                        </Typography.Paragraph>

                        <Typography.Paragraph>  
                            By sharing your data, you are directly supporting vital public-interest research and helping to ensure the development of conversational AI is transparent and beneficial for everyone.
                        </Typography.Paragraph>

                </Card>
            </Col>

            <Col xs={24} md={10}>
                    <Card
                        className={useMobileVersion ? "FeaturesCardMobile" : "FeaturesCard"}
                        itemLayout="horizontal">
                        <List>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<EyeInvisibleTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="We acknowledge that conversations can contain details that might identify you. That's why we take two key steps: first, your account information is deleted from the donation file on your computer. However this step does not fully mitigate the issue. Therefore, to protect your privacy, the conversation data is stored on secure, access-controlled servers for research."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<LockTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="Your donated data will be used for academic research and will never be shared with other third parties. Our publications will only report on trends and aggregate findings, never on individual data."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<HourglassTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="We will permanently delete all donated data from our servers within three years of the project's conclusion."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<ControlTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="Your participation is voluntary. You have complete control of what parts of the data you would like to donate."
                                />
                            </List.Item>
                            {/* <List.Item>
                                <List.Item.Meta
                                    avatar={<MoneyCollectTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="Earn up to $25!"
                                />
                            </List.Item> */}
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<QuestionCircleTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description = "For any questions, please contact us at aelfraihi@mpi-sws.org , adash@mpi-sws.org"
                                />
                            </List.Item>



                        </List>
                    </Card>
            </Col>
            </Row>
        );
};


    const title = () => {
        return 'Help researchers understand Conversational AI systems by donating your data!'
    }

return (
    <div className="HomePage">
        <Title className="Title" level={2}>
        {title()}
        </Title>

        {images()}
        {textBoxes()}
        {stepperCard()}
    </div>
    );

}
